enum UserType {
  // For users who are members of an org
  MEMBER = "member",
  // For users not members of any orgs
  PARTICIPANT = "participant",
}

enum UserLoginType {
  // If the user performed the action by itself
  ORGANIC = "organic",
  // If the user has been invited by another
  INVITED = "invited",
}

export { UserLoginType, UserType };
